<template>
    <LayoutFull v-if="route.meta.layout == 'LayoutFull'" />
    <LayoutBlank v-if="route.meta.layout == 'LayoutBlank'" />
</template>

<script setup>
import { useRoute } from "vue-router";
import LayoutFull from "./layout/LayoutFull.vue";
import LayoutBlank from "./layout/LayoutBlank.vue";

const route = useRoute();
</script>
